module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "20px 0 0 50px"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-size": "18px",
      "margin": "30px 0 20px 30px"
    }
  }, [_vm._v("店铺简介")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-left": "40px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "详细介绍 :",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "textarea",
      "maxlength": "500",
      "placeholder": "请输入店铺详细介绍（选填）",
      "rows": 5
    },
    model: {
      value: (_vm.shopIntroDetail),
      callback: function($$v) {
        _vm.shopIntroDetail = $$v
      },
      expression: "shopIntroDetail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示图片 :",
      "label-width": "120px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_vm._l((_vm.introImgArr), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "display": "inline-block",
        "position": "relative",
        "height": "80px"
      }
    }, [_c('img', {
      staticStyle: {
        "position": "absolute",
        "right": "6px",
        "top": "-8px",
        "z-index": "1",
        "width": "20px",
        "cursor": "pointer"
      },
      attrs: {
        "src": require("../../assets/img/aicon36.png")
      },
      on: {
        "click": function($event) {
          return _vm.deleteIntroImg(index)
        }
      }
    }), _vm._v(" "), _c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "display": "inline-block",
        "margin-right": "15px"
      },
      attrs: {
        "src": item,
        "preview-src-list": _vm.introImgArr,
        "fit": "cover"
      },
      on: {
        "click": _vm.handleClickItem
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.introImgArr.length < 5),
      expression: "introImgArr.length < 5"
    }],
    staticClass: "upload",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.introImgDisabled),
      expression: "introImgDisabled"
    }],
    staticClass: "avatar-uploader-zstp",
    attrs: {
      "action": "",
      "accept": ".jpg,.png",
      "show-file-list": false,
      "before-upload": _vm.beforeUploadIntroImg
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888",
      "margin-top": "8px"
    }
  }, [_vm._v("建议尺寸：1200*675，支持的图片格式：jpg、png。（选填）")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "canvasa",
      "hidden": ""
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示视频 :",
      "label-width": "120px"
    }
  }, [(_vm.introVideoSrc) ? _c('div', {
    staticClass: "videoClass"
  }, [_c('div', {
    staticClass: "previewingVideo",
    on: {
      "click": function($event) {
        return _vm.newSeevideo(_vm.introVideoSrc)
      }
    }
  }, [(_vm.introVideoImg) ? _c('img', {
    attrs: {
      "src": _vm.introVideoImg
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/img/spfm.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "iconcontainer"
  }, [_c('img', {
    staticClass: "playIcon",
    attrs: {
      "src": require("../../assets/img/play.png")
    }
  })])]), _vm._v(" "), (_vm.introVideoSrc) ? _c('img', {
    staticClass: "chahao",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        return _vm.delIntroVideo()
      }
    }
  }) : _vm._e()]) : _c('el-upload', {
    staticClass: "avatar-uploader-zstp",
    attrs: {
      "action": "",
      "accept": "video/mp4",
      "before-upload": _vm.handleIntroFile
    }
  }, [(_vm.introVideoFlag) ? _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.introVideoUploadPercent,
      "width": 80,
      "height": 80
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888",
      "margin-top": "8px"
    }
  }, [_vm._v("视频格式仅支持: mp4. 视频大小不能超过 50MB !（选填）")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.emit()
      }
    }
  }, [_vm._v("确定")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频播放",
      "visible": _vm.videoVisible,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      },
      "close": _vm.closeVideo
    }
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "图片剪裁",
      "visible": _vm.cropping,
      "append-to-body": "",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cropping = $event
      }
    }
  }, [_c('div', {
    staticClass: "cropper-content"
  }, [_c('div', {
    staticClass: "cropper"
  }, [_c('vueCropper', {
    ref: "cropper",
    attrs: {
      "img": _vm.option.img,
      "outputSize": _vm.option.size,
      "fixedBox": _vm.option.fixedBox,
      "outputType": _vm.option.outputType,
      "full": _vm.option.full,
      "canMove": _vm.option.canMove,
      "infoTrue": _vm.option.infoTrue,
      "canMoveBox": _vm.option.canMoveBox,
      "original": _vm.option.original,
      "autoCrop": _vm.option.autoCrop,
      "info": true,
      "fixed": _vm.option.fixed,
      "fixedNumber": _vm.option.fixedNumber,
      "centerBox": _vm.option.centerBox,
      "autoCropWidth": _vm.option.autoCropWidth,
      "autoCropHeight": _vm.option.autoCropHeight
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cropping = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("确认")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-89f22dac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/storeManagement/dpjj.vue
// module id = 1725
// module chunks = 3